@if (showTimetable) {
  @if (matchingProblems) {
    <div class="section highlight-background">
      <div class="label">{{departureDeviation?.stopName}}</div>
      <div class="data">
        <app-deviation-text [deviation]="departureDeviation"></app-deviation-text>
      </div>
    </div>
  }
  <div class="header">
    <div class="text" translate>
      Stop
    </div>
    <div class="text" translate>
      Departure
    </div>
  </div>
  <div class="items">
    @for (activityPointItem of items$ | async; track $index) {
      @if (activityPointItem.isLast) {
        <div class="toggle-handle" (click)="toggleShowAll()">
          @if (showAll) {
            <div class="toggle-button" translate>Show less <i class="fas fa-chevron-up"></i></div>
          } @else {
            <div class="toggle-button" translate>Show all <i class="fas fa-chevron-down"></i></div>
          }
        </div>
      }
      <div class="item" [ngClass]="{'visible': activityPointItem.visible, 'timing-point': activityPointItem.activityPoint?.isTimingPoint}">
        <div class="stop-description" [ngClass]="{'departed': activityPointItem.hasDeparted}">
          @if (activityPointItem.hasArrived) {
            <i class="fas fa-arrow-right"></i>
          }
          @if (!activityPointItem.hasArrived && activityPointItem.arrivesTo) {
            <i class="fas fa-angle-double-right"></i>
          }
          {{activityPointItem.activityPoint?.stopDescription}}
          @if (activityPointItem.activityPoint?.platformCode) {
            ({{activityPointItem.activityPoint?.platformCode}})
          }
        </div>
        @if (activityPointItem.deviation) {
          <div class="departureDeviation">
            <app-deviation-text [deviation]="activityPointItem.deviation"></app-deviation-text>
          </div>
        } @else {
          @if (!activityPointItem.hasDeparted) {
            <div class="departure">
              @if (activityPointItem.activityPoint?.isTimingPoint) {
                <i class="far fa-clock"></i>
              }
              {{activityPointItem.activityPoint?.departureTime}}
            </div>
          }
        }
      </div>
      @if (activityPointItem.isFirst && deviationMatched) {
        <div class="first-stop-divider"></div>
      }
    }
  </div>
  @if (matchingProblems) {
    <app-feedback-text type="empty">
      <span translate>Punctuality data missing (due to data matching issues)</span>
    </app-feedback-text>
  }
} @else {
  <div class="section highlight-background">
    <div class="label">{{departureDeviation?.stopName}}</div>
    <div class="data">
      <app-deviation-text [deviation]="departureDeviation"></app-deviation-text>
    </div>
  </div>
  @if (loadingTimeTable) {
    <app-feedback-text type="loading">
      <span translate>Loading more stops and punctuality data</span>
    </app-feedback-text>
  } @else {
    @if (noData) {
      <app-feedback-text type="empty">
        <span translate>Could not find stops and punctuality data for this vehicle</span>
      </app-feedback-text>
    }
  }
}

